import styled, { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
const primaryStyles = css `
  background-color: ${theme.swatches.blue[500]};
  color: ${theme.semantic.foreground.inverse};

  [data-icon='falcon'] {
    color: ${theme.semantic.foreground.inverse};
  }
`;
const secondaryStyles = css `
  background-color: ${theme.semantic.surface.sunken};
  color: ${theme.semantic.foreground.secondary};

  [data-icon='falcon'] {
    color: ${theme.semantic.foreground.secondary};
  }
`;
const successStyles = css `
  background-color: ${theme.swatches.green[500]};
  color: ${theme.semantic.foreground.inverse};

  [data-icon='falcon'] {
    color: ${theme.semantic.foreground.inverse};
  }
`;
const dangerStyles = css `
  background-color: ${theme.swatches.red[500]};
  color: ${theme.semantic.foreground.inverse};

  [data-icon='falcon'] {
    color: ${theme.semantic.foreground.inverse};
  }
`;
const warningStyles = css `
  background-color: ${theme.swatches.yellow[500]};
  color: ${theme.semantic.foreground.primary};

  [data-icon='falcon'] {
    color: ${theme.semantic.foreground.primary};
  }
`;
const infoStyles = css `
  background-color: ${theme.swatches.blue[500]};
  color: ${theme.semantic.foreground.inverse};

  [data-icon='falcon'] {
    color: ${theme.semantic.foreground.inverse};
  }
`;
const lightStyles = css `
  background-color: ${theme.semantic.surface.primary};
  color: ${theme.semantic.foreground.primary};

  [data-icon='falcon'] {
    color: ${theme.semantic.foreground.primary};
  }
`;
const darkStyles = css `
  background-color: ${theme.semantic.surface.inverse};
  color: ${theme.semantic.foreground.inverse};

  [data-icon='falcon'] {
    color: ${theme.semantic.foreground.inverse};
  }
`;
const mediumDotSizeStyles = css `
  height: ${theme.spacing.md};
  width: ${theme.spacing.md};
  border-radius: 100%;
  left: calc(100% - ${theme.spacing.md});
  transform: translate(-20%, 20%);
`;
const mediumSizeStyles = css `
  font-size: ${theme.fontSize.medium};
  height: ${theme.spacing['2xl']};
  min-width: ${theme.spacing['2xl']};
  border-radius: ${theme.spacing['2xl']};
  padding: ${pxToRem(6)};
  left: calc(100% - ${theme.spacing['2xl']} / 2);

  [data-icon='falcon'] {
    height: ${theme.spacing.lg};
    width: ${pxToRem(9)};
  }
`;
const smallDotSizeStyles = css `
  height: ${theme.spacing.sm};
  width: ${theme.spacing.sm};
  border-radius: 100%;
  left: calc(100% - ${theme.spacing.sm});
  transform: translate(-150%, 50%);
`;
const smallSizeStyles = css `
  font-size: ${theme.fontSize.small};
  height: ${pxToRem(20)};
  min-width: ${pxToRem(20)};
  border-radius: ${pxToRem(20)};
  padding: ${theme.spacing.sm};
  left: calc(100% - ${pxToRem(20)} / 1.5);

  [data-icon='falcon'] {
    height: ${theme.spacing.lg};
    width: ${pxToRem(9)};
  }
`;
const largeDotSizeStyles = css `
  height: ${theme.spacing.lg};
  min-width: ${theme.spacing.lg};
  border-radius: 100%;
  left: calc(100% - ${theme.spacing.lg});
  transform: translate(0%, 0%);
`;
const largeSizeStyles = css `
  font-size: ${theme.fontSize.large};
  height: ${theme.spacing['3xl']};
  min-width: ${theme.spacing['3xl']};
  border-radius: ${theme.spacing['3xl']};
  padding: ${theme.spacing.md};
  left: calc(100% - ${theme.spacing['3xl']} / 2.5);

  [data-icon='falcon'] {
    height: ${theme.spacing.xl};
    width: ${theme.spacing.xl};
  }
`;
const appearanceStyles = (appearance) => {
    switch (appearance) {
        case 'secondary':
            return secondaryStyles;
        case 'success':
            return successStyles;
        case 'danger':
            return dangerStyles;
        case 'info':
            return infoStyles;
        case 'dark':
            return darkStyles;
        case 'warning':
            return warningStyles;
        case 'light':
            return lightStyles;
        case 'primary':
        default:
            return primaryStyles;
    }
};
const sizeStyles = (size, dot) => {
    switch (size) {
        case 'small':
            return dot ? smallDotSizeStyles : smallSizeStyles;
        case 'large':
            return dot ? largeDotSizeStyles : largeSizeStyles;
        case 'medium':
        default:
            return dot ? mediumDotSizeStyles : mediumSizeStyles;
    }
};
const pillPositionStyles = css `
  position: absolute;
  box-sizing: border-box;
  top: 0;
  transform: translate(-20%, -20%);
`;
export const BadgeBox = styled.div `
  position: relative;
  width: max-content;
  height: max-content;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;
export const Pill = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-weight: ${theme.fontWeight.medium};
  z-index: 1;

  ${({ $adjustPosition }) => $adjustPosition && pillPositionStyles};
  ${({ $appearance }) => appearanceStyles($appearance)};
  ${({ $size, $dot }) => sizeStyles($size, $dot)}
`;
